(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-cue"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const cues = document.querySelectorAll('.scroll-cue:not([data-managed])');

    for (const cue of cues) {
      // Find the parent section element
      const parentSection = cue.closest('section, [data-section-id]');
      if (!parentSection) continue;

      // Find the next sibling section in the DOM
      const shopifyWrapper = parentSection.closest('.shopify-section');
      const nextSection = shopifyWrapper
        ? shopifyWrapper.nextElementSibling
        : parentSection.nextElementSibling;

      if (!nextSection) continue;

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              cue.classList.add('scroll-cue--hidden');
            } else {
              cue.classList.remove('scroll-cue--hidden');
            }
          }
        },
        { threshold: 0.2 }
      );

      observer.observe(nextSection);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
